// zh文件，en同理
export default {
    main: {
        a1: '操作',
        a2: '搜索',
        a3: '重置',
        a4: '编辑',
        a5: '确认',
        a6: '取消',
        a7: '删除',
        a8: '确定',
        a9: '操作成功',
        a10: '删除成功',
        b1: '折叠边栏',
        b2: '为易',
        b3: '语言',
    },
    login:{
        a1: '为易后台管理系统',
        a2: '智能一体化管理平台',
        a3: '用户名*',
        a4: '请输入用户名',
        a5: '密码*',
        a6: '请输入密码',
        a7: '记住密码',
        a8: '立即登录',
        a9: '登录成功',
        b1: '系统设置',
        b2: '重置密码',
        b3: '退出登录',
        b4: '确认退出登录？',
        b5: '重置密码成功',
        b6: '重复密码',
        b7: '请重复密码',
    },
    logs:{
        a1: '前端版本',
        a2: '后端版本',
        a3: '增加角色管理，菜单管理，权限分配等功能，优化筛选，排序功能',
        a4: '统计页面重构',
        a5: '其他已知Bug修复',
        a6: '系统整体UI修改',
        a7: '国家信息管理，短信配置管理，邮箱配置管理统一归到系统设置管理内',
        a8: '表格排序去掉取消排序选项',
        a9: '首次开发功能：首页统计、反馈信息管理、用户管理、国家信息管理、短信配置管理、邮箱配置管理',
        a10: '深圳市蓝科迅通科技有限公司',
        b1: '增加FAQ模块、产品信息模块',
        b2: '增加统计服务器归属',
        b3: '其他已知bug修复',

    },
    dashboard:{
        a1: '全部',
        a2: '最近一周',
        a3: '最近 30 天',
        a4: '最近 90 天',
        a5: '最近一年',
        a6: '新增用户',
        a7: '活跃用户',
        a8: '新增游客',
        a9: '活跃游客',
        a10: '用户服务器归属统计',
        b1: '男',
        b2: '女',
        b3: '其他',
        b4: '人',
        b5: '用户使用手机设备统计',
        b6: '使用地区分布',
        b7: '注册用户',
        b8: '远程使用',
        b9: '未知',
        b10: '总数',
        c1: '实时在线用户',
        c2: '今日累计在线',
        c3: '本周累计在线',
        c4: '本月累计在线',
        c5: '设备数量',
        c6: '用户使用设备数量统计',
        c7: '版本用户',
        c8: '应用版本用户分布',
        c9: '数据',
        c10: '图表',
        c11: '地区/国家',
        c12: '用户数量',
        c13: '远程用户数量',
        c14: '关闭',
    },
    user:{
        a1: '系统用户',
        a2: 'APP注册用户',
        a3: 'APP游客',
        a4: '请输入邮箱',
        a5: '请选择用户手机系统',
        a6: '新增用户',
        a7: '确认删除用户',
        a8: '用户名',
        a9: '请输入用户名',
        a10: '用户角色',
        b1: '请选择用户角色',
        b2: '登录名',
        b3: '请输入登录名',
        b4: '密码',
        b5: '请输入密码',
        b6: '编辑时填写密码会修改密码',
        b7: '编辑用户',
        b8: '创建时间',
        b9: '邮箱',
        b10: '性别',
        c1: '国家',
        c2: '手机型号',
        c3: '状态',
        c4: '最近在线时间',
        c5: '游客名称',
        c6: '点击降序',
        c7: '在线',
        c8: '离线',
        c9: '注册时间',
        c10: '服务器归属',
        c11: '系统版本',
        c12: 'App版本',
        c13: '应用',
        c14: '请选择应用',
        c15: '在线时长(分钟)',
        c16: '城市/省份',
        c17: '手机号',
        c18: '上线时间',
        c19: '离线时间',
        c20: '在线时长',
        c21: '分钟',
        c22: '记录',
        c23: '操作',
        c24: '设备',
        d1:'设备列表',
        d2:'是',
        d3:'否',
        d4:'自定义名称',
        d5:'型号',
        d6:'电量',
        d7:'地区',
        d8:'经销商',
        d9:'自动连接',
        d10:'固件版本',
    },
    role:{
        a1: '新增角色',
        a2: '角色名称',
        a3: '确认删除角色',
        a4: '请输入角色名称',
        a5: '菜单权限',
        a6: '请选择菜单权限',
        a7: '按钮权限',
        a8: '请选择按钮权限',
        a9: '编辑角色',
    },
    menu:{
        a1: '新增菜单',
        a2: '系统菜单',
        a3: '添加子菜单',
        a4: '确认删除菜单',
        a5: '功能菜单',
        a6: '菜单名称',
        a7: '请输入菜单名称',
        a8: '菜单路由',
        a9: '请输入菜单路由',
        a10: '菜单图标',
        b1: '请选择菜单图标',
        b2: '菜单排序',
        b3: '请输入菜单排序号',
        b4: '菜单类型',
        b5: '请选择菜单类型',
        b6: '新增可控按钮',
        b7: '按钮名称',
        b8: '请输入按钮名称',
        b9: '权限信息',
        b10: '请输入权限信息',
        c1: '该菜单内已存在可控按钮，不能添加子菜单',
        c2: '编辑菜单',
    },
    feedback:{
        a1: '反馈',
        a2: '举报',
        a3: '未回复',
        a4: '已回复',
        a5: '回复失败',
        a6: '确认删除该条反馈信息？',
        a7: '回复标题',
        a8: '请输入回复标题',
        a9: '回复内容',
        a10: '请输入回复内容',
        b1: '回复反馈信息',
        b2: '反馈人',
        b3: '反馈人邮箱',
        b4: '反馈人地区',
        b5: '反馈人使用手机（版本）',
        b6: '反馈信息',
        b7: '反馈类型',
        b8: '状态',
        b9: '反馈时间',
        b10: '更多',
    },
    setting:{
        a1: '国家信息配置',
        a2: '邮箱配置',
        a3: '短信配置',
        a4: '新增国家',
        a5: '国家名称',
        a6: '国家区号',
        a7: '国家标识',
        a8: '确认删除国家',
        a9: '国家缩写',
        a0: '请输入国家缩写',
        b1: '请输入国家电话地区号',
        b2: '请输入国家名称',
        b3: '请输入国家标识',
        b4: '编辑国家',
        b5: '新增邮箱配置',
        b6: '国家',
        b7: '发送人地址',
        b8: '发送方名称',
        b9: 'smtp服务器地址',
        b10: '端口',
        c1: '确认删除邮箱配置？',
        c2: '名称',
        c3: '请输入发送人名称',
        c4: '地址',
        c5: '请输入发送人地址',
        c6: '邮箱SMTP',
        c7: '请输入邮箱SMTP服务器',
        c8: '授权码',
        c9: '请输入发送人授权码',
        c10: 'SMTP端口',
        d1: '请输入SMTP服务器端口',
        d2: '请选择国家标识',
        d3: '新增邮箱配置',
        d4: '编辑邮箱配置',
        d5: '新增短信配置',
        d6: '授权标识ID',
        d7: '授权标识密钥',
        d8: '签名',
        d9: '短信模板代码',
        d10: '确认删除该短信配置？',
        e1: '请输入授权标识ID',
        e2: '请输入短信模板代码',
        e3: '请输入短信签名',
        e4: '请输入授权标识密钥',
        e5: '编辑短信配置',
        e6: '短信签名',
    },
    faq:{
        a1: '请输入搜索内容',
        a2: '添加FAQ',
        a3: '序号',
        a4: '确认删除该FAQ？',
        a5: '编辑FAQ',
        a6: '添加语言',
        a7: '请输入问题',
        a8: '请输入答案',
        a9: '请最少添加其中一种语言的FAQ',
        a10: '请补充{msg}的问题',
        b1: '请补充{msg}的答案',
    },
    product:{
        a1: '请输入为易产品型号',
        a2: '请输入迅通产品型号',
        a3: '请输入设备类型码',
        a4: '请选择主控类型',
        a5: '添加产品',
        a6: '无',
        a7: '确认删除该产品?',
        a8: '产品图片',
        a9: 'WYPID',
        a10: '迅通产品型号',
        b1: 'XTPID',
        b2: '主控类型',
        b3: '编辑产品',
        b4: '产品名称',
        b5: '请输入产品名称',
        b6: '产品描述',
        b7: '请输入产品描述',
        b8: '产品详情图',
        b9: '查看大图',
        b10: '请最少添加其中一种语言的产品内容',
        c1: '请上传产品图片',
        c2: '请补充{msg}的产品名称',
        c3: '请补充{msg}的产品描述',
        c4: '只能上传JPG/PNG文件！',
        c5: '图像必须小于2MB！',
    },
    app:{
        a1:'应用名称',
        a2:'应用Key',
        a3:'应用图标',
        b1:'请输入应用名称',
        b2:'请上传应用图标',
        b3:'请确认删除该应用',
        c1:'新增应用',
        c2:'编辑应用',
        c3:'复制数据',
        c4:'请选择需要复制数据的应用',

    },
    agreement:{
        a1:'协议标题',
        a2:'协议语言',
        a3:'协议Key',
        a4:'外部访问地址',
        a5:'协议类型',
        b1:'请输入协议标题',
        b2:'请选择协议语言',
        b3:'请输入协议内容',
        b4:'请确认删除该协议',
        b5:'请选择协议类型',
        c1:'新增协议',
        c2:'编辑协议',
        c3:'查看链接',
        c4:'用户协议',
        c5:'隐私协议'

    },
    "登录": "登录",
    "首页": "首页",
    "用户": "用户",
    "角色": "角色",
    "菜单": "菜单",
    "版本记录": "版本记录",
    "总览": "总览",
    "反馈": "反馈",
    "系统设置": "系统设置",
    "产品": "产品",
    "添加产品": "添加产品",
    "编辑产品": "编辑产品",
    "添加FAQ": "添加FAQ",
    "编辑FAQ": "编辑FAQ",
    "APP": "APP",
    "FAQ": "FAQ",
    "应用": "应用",
    "协议": "协议",

    "DZ": "阿尔及利亚",
    "AO": "安哥拉",
    "BJ": "贝宁",
    "BW": "博茨瓦纳",
    "BF": "布基纳法索",
    "BI": "布隆迪",
    "CV": "佛得角",
    "CM": "喀麦隆",
    "CF": "中非共和国",
    "TD": "乍得",
    "KM": "科摩罗",
    "CG": "刚果",
    "CI": "科特迪瓦",
    "DJ": "吉布提",
    "EG": "埃及",
    "GQ": "赤道几内亚",
    "ER": "厄立特里亚",
    "ET": "埃塞俄比亚",
    "GA": "加蓬",
    "GM": "冈比亚",
    "GH": "加纳",
    "GN": "几内亚",
    "GW": "几内亚比绍",
    "KE": "肯尼亚",
    "LS": "莱索托",
    "LR": "利比里亚",
    "LY": "利比亚",
    "MG": "马达加斯加",
    "MW": "马拉维",
    "ML": "马里",
    "MR": "毛里塔尼亚",
    "MU": "毛里求斯",
    "MA": "摩洛哥",
    "MZ": "莫桑比克",
    "NA": "纳米比亚",
    "NE": "尼日尔",
    "NG": "尼日利亚",
    "RW": "卢旺达",
    "ST": "圣多美和普林西比",
    "SN": "塞内加尔",
    "SC": "塞舌尔",
    "SL": "塞拉利昂",
    "SO": "索马里",
    "ZA": "南非",
    "SS": "南苏丹",
    "SD": "苏丹",
    "TZ": "坦桑尼亚",
    "TG": "多哥",
    "TN": "突尼斯",
    "UG": "乌干达",
    "ZM": "赞比亚",
    "ZW": "津巴布韦",
    "AF": "阿富汗",
    "AM": "亚美尼亚",
    "AZ": "阿塞拜疆",
    "BH": "巴林",
    "BD": "孟加拉国",
    "BT": "不丹",
    "BN": "文莱",
    "KH": "柬埔寨",
    "CN": "中国",
    "CY": "塞浦路斯",
    "GE": "格鲁吉亚",
    "IN": "印度",
    "ID": "印度尼西亚",
    "IR": "伊朗",
    "IQ": "伊拉克",
    "IL": "以色列",
    "JP": "日本",
    "JO": "约旦",
    "KZ": "哈萨克斯坦",
    "KP": "朝鲜",
    "KR": "韩国",
    "KW": "科威特",
    "KG": "吉尔吉斯斯坦",
    "LA": "老挝",
    "LB": "黎巴嫩",
    "MY": "马来西亚",
    "MV": "马尔代夫",
    "MN": "蒙古",
    "MM": "缅甸",
    "NP": "尼泊尔",
    "OM": "阿曼",
    "PK": "巴基斯坦",
    "PS": "巴勒斯坦",
    "PH": "菲律宾",
    "QA": "卡塔尔",
    "SA": "沙特阿拉伯",
    "SG": "新加坡",
    "LK": "斯里兰卡",
    "SY": "叙利亚",
    "TJ": "塔吉克斯坦",
    "TH": "泰国",
    "TL": "东帝汶",
    "TR": "土耳其",
    "TM": "土库曼斯坦",
    "AE": "阿拉伯联合酋长国",
    "UZ": "乌兹别克斯坦",
    "VN": "越南",
    "YE": "也门",
    "AL": "阿尔巴尼亚",
    "AD": "安道尔",
    "AT": "奥地利",
    "BY": "白俄罗斯",
    "BE": "比利时",
    "BA": "波黑",
    "BG": "保加利亚",
    "HR": "克罗地亚",
    "CZ": "捷克共和国",
    "DK": "丹麦",
    "EE": "爱沙尼亚",
    "FI": "芬兰",
    "FR": "法国",
    "DE": "德国",
    "GR": "希腊",
    "HU": "匈牙利",
    "IS": "冰岛",
    "IE": "爱尔兰",
    "IT": "意大利",
    "LV": "拉脱维亚",
    "LT": "立陶宛",
    "LU": "卢森堡",
    "MK": "北马其顿",
    "MT": "马耳他",
    "MD": "摩尔多瓦",
    "MC": "摩纳哥",
    "ME": "黑山",
    "NL": "荷兰",
    "NO": "挪威",
    "PL": "波兰",
    "PT": "葡萄牙",
    "RO": "罗马尼亚",
    "RU": "俄罗斯",
    "SM": "圣马力诺",
    "RS": "塞尔维亚",
    "SK": "斯洛伐克",
    "SI": "斯洛文尼亚",
    "ES": "西班牙",
    "SE": "瑞典",
    "CH": "瑞士",
    "UA": "乌克兰",
    "GB": "英国",
    "VA": "梵蒂冈",
    "AG": "安提瓜和巴布达",
    "AR": "阿根廷",
    "BS": "巴哈马",
    "BB": "巴巴多斯",
    "BZ": "伯利兹",
    "BO": "玻利维亚",
    "BR": "巴西",
    "CL": "智利",
    "CO": "哥伦比亚",
    "CR": "哥斯达黎加",
    "CU": "古巴",
    "DM": "多米尼克",
    "DO": "多米尼加共和国",
    "EC": "厄瓜多尔",
    "SV": "萨尔瓦多",
    "GD": "格林纳达",
    "GT": "危地马拉",
    "GY": "圭亚那",
    "HT": "海地",
    "HN": "洪都拉斯",
    "JM": "牙买加",
    "MX": "墨西哥",
    "NI": "尼加拉瓜",
    "PA": "巴拿马",
    "PY": "巴拉圭",
    "PE": "秘鲁",
    "PR": "波多黎各",
    "KN": "圣基茨和尼维斯",
    "LC": "圣卢西亚",
    "VC": "圣文森特和格林纳丁斯",
    "SR": "苏里南",
    "TT": "特立尼达和多巴哥",
    "UY": "乌拉圭",
    "VE": "委内瑞拉",
    "CA": "加拿大",
    "US": "美国",
    "GL": "格陵兰",
    "AU": "澳大利亚",
    "NZ": "新西兰",
    "PG": "巴布亚新几内亚",
    "FJ": "斐济",
    "SB": "所罗门群岛",
    "VU": "瓦努阿图",
    "PW": "帕劳",
    "FM": "密克罗尼西亚联邦",
    "MH": "马绍尔群岛",
    "KI": "基里巴斯",
    "NR": "瑙鲁",
    "WS": "萨摩亚",
    "TO": "汤加",
    "TV": "图瓦卢",
    "CK": "库克群岛",
    "NU": "纽埃",
    "PF": "法属波利尼西亚",
    "SZ": "斯威士兰",
    "LI": "列支顿士登",
    "EH": "西撒哈拉",
    "AS": "东萨摩亚",
    "BM": "百慕大",
    "FK": "福兰克群岛",
    "HM": "赫德和麦克唐纳群岛",
    "NC": "新卡里多尼亚",
    "GS": "乔治亚岛和三明治群岛",
    "1":"未知",
    "-1":"未知"
}
